export default __webpack_public_path__ + "static/favicon-b7ed505e97f475ed5f3c02944a4fa411.ico";